import Vue from 'vue'
import App from './App'
import router from './router'
import FormLine from './components/FormLine'
import Pagination from './components/Pagination'
import VueSwal from 'vue-swal'
import VueToastr from 'vue-toastr'
import strip from 'striptags'
import VueMoment from 'vue-moment'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

require('vue-toastr/src/vue-toastr.less')
Vue.use(VueToastr)

require('moment/locale/id')

Vue.use(VueMoment, {
  moment
})

var Waves = require('vue-directive-waves')
Vue.use(Waves)
Vue.component('formline', FormLine)
Vue.component('pagination', Pagination)
Vue.use(VueSwal)
Vue.use(VueQuillEditor)

Vue.mixin({
  methods: {
    stripTags: function (string) {
      return strip(string)
    }
  }
})

Vue.use(flatPickr)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  mounted: function () {
    this.$toastr.defaultProgressBar = false
  }
})



// WEBPACK FOOTER //
// ./src/main.js